import classes from "./Thankyou.module.css";
import Termsclasses from "../Terms/Terms.module.css";
import Footer from "../Footer/Footer";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ApprovedPass = () => {
    const location = useLocation();
    let status = location.state.status;
  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener("popstate", function (event) {
      window.history.pushState(null, document.title, window.location.href);
    });
  });
  return (
    <>
      <div className={classes.centerContent}>
        <p>{status === "approved" ? "Approved" : "Rejected"} Action Already Taken, Thank you!</p>
      </div>
      <Footer footerColor={"black"} />
    </>
  );
};

export default ApprovedPass;
